import React from 'react';
import AuthRoute from './AuthRoute';
import UnauthRoute from './UnauthRoute';
import Login from 'pages/auth/login';
import Dashboard from 'pages/overview';
import Meals from 'pages/meals';
import FeedsList from 'pages/feeds/feeds-list';
import Settings from 'pages/settings';
import Trash from 'pages/trash';
import MealMetadata from 'pages/metadata/meal-metadata';

import AppSettings from 'pages/settings/app-settings';
import DashboardIndex from 'pages/dashboard';
import BrandDetailsPage from 'pages/brand-details/brand-details-page';
import BrandPreview from 'pages/create-brand/create-brand-preview';
import BrandDetailsOpeningTime from 'pages/brand-details/brand-details-opening-time';
import BrandDetailsMetadata from 'pages/brand-details/brand-details-metadata';
import BrandDetailsIndex from 'pages/brand-details';
import CreateBrandIndex from 'pages/create-brand';
import CreateBrandDetails from 'pages/create-brand/create-brand-details';
import CreateBrandImages from 'pages/create-brand/create-brand-images';
import CreateBrandOpeningTime from 'pages/create-brand/create-brand-opening-time';
import CreateBrandMetadata from 'pages/create-brand/create-brand-metadata';
import { RouteObject, createBrowserRouter } from 'react-router-dom';
import SettingsLayout from 'pages/settings/layout';
import NewFeed from 'pages/feeds/new-feed';
import FeedsLayout from 'pages/feeds';
import BrandMetadata from 'pages/metadata/brand-metadata';
import NewMealIndex from 'pages/new-meal';
import NewMealDetails from 'pages/new-meal/meal-details';
import NewMealMetadataInfo from 'pages/new-meal/meal-metadata-info';
import NewMealBrandDetails from 'pages/new-meal/brand-details';
import EditMealIndex from 'pages/edit-meal';
import EditMealBrandDetails from 'pages/edit-meal/brand-details';
import EditMealDetails from 'pages/edit-meal/meal-details';
import ConvertMealCategoryToAddonCategory from 'pages/meals/convert-meal-category-to-addon-category';
import NewMealCategory from 'pages/new-meal-category';
import NewMealXlsIndex from 'pages/new-meal-xls';
import UploadXlsMeals from 'pages/new-meal-xls/upload-meals';
import ReviewXlsMeals from 'pages/new-meal-xls/review-meals';
import EditMealMetadataInfo from 'pages/edit-meal/meal-metadata-info';
import MealAddonCategories from 'pages/meals/meal-addon-categories';
import ConvertMealtoAddon from 'pages/meals/convert-meal-to-addon';
import CategoryMeals from 'pages/meals/meal-category-meals-page';
import DuplicateMeal from 'pages/meals/duplicate-meal';
import Pricing from 'pages/pricing';
import Search from 'pages/search';
import CreateAddonCategory from 'pages/overview/create-addon-category';
import NewAddonIndex from 'pages/new-addon';
import NewAddonDetails from 'pages/new-addon/new-addon-details';
import NewAddonPreview from 'pages/new-addon/new-addon-preview';
import UpdateAddonCategory from 'pages/update-addon-category';
import MultipleBrandWorkingHours from 'pages/multiple-brand-working-hours';
import DuplicateAddon from 'pages/meals/duplicate-addon-page';
import DuplicateAddonCategory from 'pages/meals/duplicate-addon-category-page';
import CreateCokitchen from 'pages/create-cokitchen';
import CreateCokitchenKitchen from 'pages/create-cokitchen/create-cokitchen-kitchen';
import CreateCokitchenPolygon from 'pages/create-cokitchen/create-cokitchen-polygon';
import CreateCokitchenBrands from 'pages/create-cokitchen/create-cokitchen-brands';
import PopupKitchenList from 'pages/popup-kitchen';
import CokitchenDetailsIndex from 'pages/cokitchen-details';
import CokitchenPolygon from 'pages/cokitchen-details/cokitchen-polygon';
import CokitchenDetailsPage from 'pages/cokitchen-details/cokitchen-details-page';
import CokitchenPreview from 'pages/create-cokitchen/create-cokitchen-preview';
import TrashedMeals from 'pages/trash/trashed-meals';
import TrashedMealCategories from 'pages/trash/trashed-meal-categories';
import TrashedAddons from 'pages/trash/trashed-addons';
import TrashedAddonCategories from 'pages/trash/trashed-addon-categories';
import TrashedBrands from 'pages/trash/trashed-brands';
import PaymentSettings from 'pages/settings/payment-settings';
import OtherSettings from 'pages/settings/other-settings';
import Maintenance from 'pages/rewards/maintenance';

import ConversionRate from 'pages/rewards/maintenance/conversion-rate';
import StreakControl from 'pages/rewards/maintenance/streak-control';
import PauseControl from 'pages/rewards/maintenance/pause-control';
import CashbackControl from 'pages/rewards/maintenance/cashback-control';
import { ROUTE_KEYS, ROUTE_PREFIX } from 'utils/constants';
import NewMealLayout from 'layouts/new-meal.layout';
import EditMealLayout from 'layouts/edit-meal.layout';
import BrandLayout from 'layouts/brand.layout';
import CreateBrandLayout from 'layouts/create-brand.layout';
import NewMealXlsLayout from 'layouts/new-meal-xls.layout';
import NewMealCategoryLayout from 'layouts/new-meal-category.layout';
import CreateCokitchenLayout from 'layouts/create-cokitchen.layout';
import CokitchenLayout from 'layouts/cokitchen.layout';
import Levels from 'pages/rewards/levels';
import Categories from 'pages/gift-cards/categories';
import PlainDesigns from 'pages/gift-cards/plain-designs';
import DashboardLayout from 'layouts/dashboard.layout';
import Streaks from 'pages/rewards/streaks';
import GiftcardCategoryDetailsPage from 'pages/gift-cards/categories/category-details';
import CreateGiftCardCategory from 'pages/gift-cards/categories/create-giftcard-category';
import BaseMeal from 'pages/base-items/base-meal';
import NewBaseMeal from 'pages/base-items/base-meal/new-base-meal';
import EditBaseMeal from 'pages/base-items/base-meal/edit-base-meal';
import NewBaseAddonCategory from 'pages/base-items/base-addon-category/new-base-addon-category';
import EditBaseAddonCategory from 'pages/base-items/base-addon-category/edit-base-addon-category';
import BaseAddonCategory from 'pages/base-items/base-addon-category';
import UploadBaseMeal from 'pages/base-items/base-meal/upload-base-meal';
import UploadBaseAddonCategory from 'pages/base-items/base-addon-category/upload-base-addon-category/upload-page';
import BaseAddonCategoryXlsLayout from 'layouts/base-addon-category-xls.layout';
import BaseAddonCategoryXlsIndex from 'pages/base-items/base-addon-category/upload-base-addon-category';
import ReviewBaseAddonCategory from 'pages/base-items/base-addon-category/upload-base-addon-category/review-page';
import NewAddonLayout from 'layouts/new-addon.layout';
import ManageBaseMeal from 'pages/manage-base-meal';
import MealsByBase from 'pages/meals/meals-by-base';
import MealsByBaseAddonCategory from 'pages/base-items/base-addon-category/meals-by-base-addon-category';
import CreateCokitchenExpore from 'pages/create-cokitchen/create-cokitchen-explore';
import CreateCareerPositionLayout from 'layouts/create-career-position.layout';
import CreateJobIndex from 'pages/create-career-position';
import CreateJobDetails from 'pages/create-career-position/create-job-details';
import CreateJobDescription from 'pages/create-career-position/create-job-description';
import CreateApplicationSettings from 'pages/create-career-position/create-application-settings';
import CreateJobPreview from 'pages/create-career-position/create-job-preview';
import CareersListingPage from 'pages/career/page';
import CreateBrandPolygon from 'pages/create-brand/create-brand-polygons';
import BrandDetailsPolygon from 'pages/brand-details/brand-details-polygon';
import QrCode from 'pages/qr-code';
import CareerDetailsIndex from 'pages/career-details';
import JobDetails from 'pages/career-details/job-details';
import JobDescription from 'pages/career-details/job-description';
import JobApplicationsPage from 'pages/career-details/job-application-settings';
import CareerLayout from 'layouts/career.layout';
import DineInKitchenList from 'pages/dine-in-kitchen';
import Blogs from 'pages/blogs';
import CreateBlogBody from 'pages/create-blog/create-blog-body';
import CreateBlogImage from 'pages/create-blog/create-blog-image';
import CreateBlogPreview from 'pages/create-blog/create-blog-preview';
import CreateBlogIndex from 'pages/create-blog';
import CreateBlogLayout from 'layouts/create-blog.layout';
import { SHOP_DASHBOARD_ROUTES } from './shop.routes';
import SectionForm from 'pages/manage-section/section-form';
import ManageSectionFormLayout from 'layouts/section-form.layout';

const COKITCHEN_DETAILS_ROUTES: RouteObject[] = [
  {
    index: true,
    element: <CokitchenDetailsIndex />
  },
  {
    path: ROUTE_KEYS.BRAND_DETAILS_PAGE,
    element: <CokitchenDetailsPage />
  }
];
const CREATE_COKITCHEN_ROUTES: RouteObject[] = [
  {
    index: true,
    element: <CreateCokitchen />
  },
  {
    path: ROUTE_KEYS.CREATE_COKITCHEN_KITCHEN,
    element: <CreateCokitchenKitchen />
  },
  {
    path: ROUTE_KEYS.CREATE_COKITCHEN_POLYGON,
    element: <CreateCokitchenPolygon />
  },
  {
    path: ROUTE_KEYS.CREATE_COKITCHEN_EXPLORE,
    element: <CreateCokitchenExpore />
  },
  {
    path: ROUTE_KEYS.CREATE_COKITCHEN_BRANDS,
    element: <CreateCokitchenBrands />
  },
  {
    path: ROUTE_KEYS.CREATE_COKITCHEN_PREVIEW,
    element: <CokitchenPreview />
  }
];
const TRASH_ROUTES: RouteObject[] = [
  {
    index: true,
    element: <Trash />
  },
  {
    path: ROUTE_KEYS.TRASH_BRAND,
    element: <TrashedBrands />
  },

  {
    path: ROUTE_KEYS.TRASH_MEAL,
    element: <TrashedMeals />
  },
  {
    path: ROUTE_KEYS.TRASH_MEAL_CATEGORY,
    element: <TrashedMealCategories />
  },
  {
    path: ROUTE_KEYS.TRASH_ADDON,
    element: <TrashedAddons />
  },
  {
    path: ROUTE_KEYS.TRASH_ADDON_CATEGORY,
    element: <TrashedAddonCategories />
  }
];
const BRAND_DETAILS_ROUTES: RouteObject[] = [
  {
    index: true,
    element: <BrandDetailsIndex />
  },
  {
    path: ROUTE_KEYS.BRAND_DETAILS_PAGE,
    element: <BrandDetailsPage />
  },
  {
    path: ROUTE_KEYS.BRAND_OPENING_TIME,
    element: <BrandDetailsOpeningTime />
  },
  {
    path: ROUTE_KEYS.BRAND_DETAILS_METADATA,
    element: <BrandDetailsMetadata />
  },
  {
    path: ROUTE_KEYS.BRAND_POLYGON,
    element: <BrandDetailsPolygon />
  }
];
const JOB_DETAILS_ROUTES: RouteObject[] = [
  {
    index: true,
    element: <CareerDetailsIndex />
  },
  {
    path: ROUTE_KEYS.CAREER_DETAILS_PAGE,
    element: <JobDetails />
  },
  {
    path: ROUTE_KEYS.CAREER_DESCRIPTION,
    element: <JobDescription />
  },
  {
    path: ROUTE_KEYS.CAREER_SETTINGS,
    element: <JobApplicationsPage />
  }
];

const CREATE_BRAND_ROUTES: RouteObject[] = [
  {
    index: true,
    element: <CreateBrandIndex />
  },
  {
    path: ROUTE_KEYS.CREATE_BRAND_DETAILS,
    element: <CreateBrandDetails />
  },
  {
    path: ROUTE_KEYS.CREATE_BRAND_IMAGES,
    element: <CreateBrandImages />
  },
  {
    path: ROUTE_KEYS.CREATE_BRAND_OPENING_TIME,
    element: <CreateBrandOpeningTime />
  },
  {
    path: ROUTE_KEYS.CREATE_BRAND_POLYGON,
    element: <CreateBrandPolygon />
  },
  {
    path: ROUTE_KEYS.CREATE_BRAND_METADATA,
    element: <CreateBrandMetadata />
  },
  {
    path: ROUTE_KEYS.CREATE_BRAND_PREVIEW,
    element: <BrandPreview />
  }
];

const NEW_MEAL_ROUTES: RouteObject[] = [
  {
    index: true,
    element: <NewMealIndex />
  },
  {
    path: ROUTE_KEYS.NEW_MEAL_BRAND_DETAILS,
    element: <NewMealBrandDetails />
  },
  {
    path: ROUTE_KEYS.NEW_MEAL_DETAILS,
    element: <NewMealDetails />
  },
  {
    path: ROUTE_KEYS.NEW_MEAL_METADATA,
    element: <NewMealMetadataInfo />
  }
];

const NEW_MEAL_CATEGORY_ROUTES: RouteObject[] = [
  {
    index: true,
    element: <NewMealCategory />
  }
];
const NEW_ADDON_ROUTES: RouteObject[] = [
  {
    index: true,
    element: <NewAddonIndex />
  },
  {
    path: ROUTE_KEYS.NEW_ADDON_DETAILS,
    element: <NewAddonDetails />
  },
  {
    path: ROUTE_KEYS.NEW_ADDON_PREVIEW,
    element: <NewAddonPreview />
  }
];

const EDIT_MEAL_ROUTES: RouteObject[] = [
  {
    index: true,
    element: <EditMealIndex />
  },
  {
    path: ROUTE_KEYS.EDIT_MEAL_BRAND_DETAILS,
    element: <EditMealBrandDetails />
  },
  {
    path: ROUTE_KEYS.EDIT_MEAL_DETAILS,
    element: <EditMealDetails />
  },
  {
    path: ROUTE_KEYS.EDIT_MEAL_METADATA,
    element: <EditMealMetadataInfo />
  }
];

const NEW_MEAL_XLS_ROUTES: RouteObject[] = [
  {
    index: true,
    element: <NewMealXlsIndex />
  },
  {
    path: ROUTE_KEYS.NEW_MEAL_XLS_UPLOAD,
    element: <UploadXlsMeals />
  },
  {
    path: ROUTE_KEYS.NEW_MEAL_XLS_REVIEW,
    element: <ReviewXlsMeals />
  }
];

const BASE_ADDON_CATEGORY_XLS_ROUTES: RouteObject[] = [
  {
    index: true,
    element: <BaseAddonCategoryXlsIndex />
  },
  {
    path: ROUTE_KEYS.BASE_ADDON_CATEGORY_XLS_UPLOAD,
    element: <UploadBaseAddonCategory />
  },
  {
    path: ROUTE_KEYS.BASE_ADDON_CATEGORY_XLS_REVIEW,
    element: <ReviewBaseAddonCategory />
  }
];

const SETTINGS_ROUTES: RouteObject[] = [
  {
    index: true,
    element: <Settings />
  },
  {
    path: ROUTE_KEYS.APP_SETTINGS,
    element: <AppSettings />
  },
  {
    path: ROUTE_KEYS.PAYMENT_SETTINGS,
    element: <PaymentSettings />
  },
  {
    path: ROUTE_KEYS.OTHER_SETTINGS,
    element: <OtherSettings />
  }
];

const FEED_ROUTES: RouteObject[] = [
  {
    index: true,
    element: <FeedsList />
  },
  {
    path: ROUTE_KEYS.NEW_FEED,
    element: <NewFeed />
  }
];

const BLOG_FORM_ROUTES: RouteObject[] = [
  {
    index: true,
    element: <CreateBlogIndex />
  },
  {
    path: ROUTE_KEYS.CREATE_BLOG_BODY,
    element: <CreateBlogBody />
  },
  {
    path: ROUTE_KEYS.CREATE_BLOG_IMAGE,
    element: <CreateBlogImage />
  },
  {
    path: ROUTE_KEYS.CREATE_BLOG_PREVIEW,
    element: <CreateBlogPreview />
  }
];

const CAREER_POSITION_FORM_ROUTES: RouteObject[] = [
  {
    index: true,
    element: <CreateJobIndex />
  },
  {
    path: ROUTE_KEYS.CREATE_POSITION_FORM_DETAILS,
    element: <CreateJobDetails />
  },
  {
    path: ROUTE_KEYS.CREATE_POSITION_FORM_DESCRIPTION,
    element: <CreateJobDescription />
  },
  {
    path: ROUTE_KEYS.CREATE_POSITION_FORM_APP_SETTINGS,
    element: <CreateApplicationSettings />
  },

  {
    path: ROUTE_KEYS.CREATE_POSITION_FORM_PREVIEW,
    element: <CreateJobPreview />
  }
];

const MANAGE_SECTION_ROUTES = [
  {
    index: true,
    element: <div></div>
  },

  {
    path: ROUTE_KEYS.MANAGE_CREATE_SECTION,
    element: <SectionForm />
  },
  {
    path: ROUTE_KEYS.MANAGE_EDIT_SECTION,
    element: <SectionForm />
  }
];

const FOOD_DASHBOARD_ROUTES: RouteObject[] = [
  {
    index: true,
    element: <DashboardIndex />
  },
  {
    path: ROUTE_KEYS.OVERVIEW,
    element: <Dashboard />
  },
  {
    path: ROUTE_KEYS.BRAND_DETAILS,
    element: <BrandLayout />,
    children: BRAND_DETAILS_ROUTES
  },

  {
    path: ROUTE_KEYS.EDIT_MULTIPLE_BRANDS,
    element: <MultipleBrandWorkingHours />
  },
  {
    path: ROUTE_KEYS.MEALS,
    element: <Meals />
  },

  {
    path: ROUTE_KEYS.NEW_MEAL,
    element: <NewMealLayout />,
    children: NEW_MEAL_ROUTES
  },
  {
    path: ROUTE_KEYS.EDIT_MEAL,
    element: <EditMealLayout />,
    children: EDIT_MEAL_ROUTES
  },
  {
    path: ROUTE_KEYS.CONVERT_MEAL_TO_ADDON,
    element: <ConvertMealtoAddon />
  },
  {
    path: ROUTE_KEYS.CONVERT_MEAL_CATEGORY_TO_ADDON_CATEGORY,
    element: <ConvertMealCategoryToAddonCategory />
  },
  {
    path: ROUTE_KEYS.DUPLICATE_MEAL,
    element: <DuplicateMeal />
  },
  {
    path: ROUTE_KEYS.ADDON_CATEGORIES,
    element: <MealAddonCategories />
  },
  {
    path: `${ROUTE_KEYS.ADDON_CATEGORIES}/${ROUTE_KEYS.DUPLICATE_ADDON_CATEGORY}/${ROUTE_KEYS.ADDON_TITLE}`,
    element: <DuplicateAddonCategory />
  },
  {
    path: `${ROUTE_KEYS.ADDON_CATEGORIES}/${ROUTE_KEYS.UPDATE_ADDON_CATEGORY}/${ROUTE_KEYS.ADDON_TITLE}`,
    element: <UpdateAddonCategory />
  },
  {
    path: `${ROUTE_KEYS.ADDON_CATEGORIES}/${ROUTE_KEYS.DUPLICATE_ADDON}/${ROUTE_KEYS.ADDON_TITLE}`,
    element: <DuplicateAddon />
  },
  {
    path: ROUTE_KEYS.CREATE_BRAND,
    element: <CreateBrandLayout />,
    children: CREATE_BRAND_ROUTES
  },

  {
    path: ROUTE_KEYS.NEW_MEAL_XLS,
    element: <NewMealXlsLayout />,
    children: NEW_MEAL_XLS_ROUTES
  },
  {
    path: ROUTE_KEYS.BASE_ADDON_CATEGORY_XLS,
    element: <BaseAddonCategoryXlsLayout />,
    children: BASE_ADDON_CATEGORY_XLS_ROUTES
  },
  {
    path: ROUTE_KEYS.NEW_MEAL_CATEGORY,
    element: <NewMealCategoryLayout />,
    children: NEW_MEAL_CATEGORY_ROUTES
  },
  {
    path: ROUTE_KEYS.NEW_ADDON,
    element: <NewAddonLayout />,
    children: NEW_ADDON_ROUTES
  },

  {
    path: ROUTE_KEYS.KITCHEN_LIST,
    element: <PopupKitchenList />
  },
  {
    path: ROUTE_KEYS.DINE_IN_LIST,
    element: <DineInKitchenList />
  },
  {
    path: ROUTE_KEYS.CREATE_COKITCHEN,
    element: <CreateCokitchenLayout />,
    children: CREATE_COKITCHEN_ROUTES
  },
  {
    path: ROUTE_KEYS.COKITCHEN_DETAILS,
    element: <CokitchenLayout />,
    children: COKITCHEN_DETAILS_ROUTES
  },
  {
    path: ROUTE_KEYS.POLYGON,
    element: <CokitchenPolygon />
  },
  {
    path: ROUTE_KEYS.CATEGORY_MEALS,
    element: <CategoryMeals />
  },
  {
    path: ROUTE_KEYS.POPUP_KITCHEN,
    element: <PopupKitchenList />
  },

  {
    path: ROUTE_KEYS.MEAL_METADATA,
    element: <MealMetadata />
  },

  {
    path: ROUTE_KEYS.BRAND_METADATA,
    element: <BrandMetadata />
  },

  {
    path: ROUTE_KEYS.MEALS_BY_BASE,
    element: <MealsByBase />
  },
  {
    path: ROUTE_KEYS.MEALS_BY_CATEGORY,
    element: <Meals />
  },
  {
    path: ROUTE_KEYS.BASE_MEAL,
    element: <BaseMeal />
  },

  {
    path: ROUTE_KEYS.BASE_ADDON_CATEGORY,
    element: <BaseAddonCategory />
  },

  {
    path: ROUTE_KEYS.BASE_MEAL_UPLOAD,
    element: <UploadBaseMeal />
  },

  {
    path: ROUTE_KEYS.PRICING,
    element: <Pricing />
  },
  {
    path: ROUTE_KEYS.MANAGE_BASE_MEALS,
    element: <ManageBaseMeal />
  },
  {
    path: ROUTE_KEYS.MEAL_BY_BASE_ADDON_CATEGORY,
    element: <MealsByBaseAddonCategory />
  },
  {
    path: ROUTE_KEYS.SEARCH,
    element: <Search />
  },
  {
    path: ROUTE_KEYS.NEW_ADDON_CATEGORY,
    element: <CreateAddonCategory />
  },

  {
    path: ROUTE_KEYS.NEW_BASE_MEAL,
    element: <NewBaseMeal />
  },
  {
    path: ROUTE_KEYS.EDIT_BASE_MEAL,
    element: <EditBaseMeal />
  },

  {
    path: ROUTE_KEYS.NEW_BASE_ADDON_CATEGORY,
    element: <NewBaseAddonCategory />
  },
  {
    path: ROUTE_KEYS.EDIT_BASE_ADDON_CATEGORY,
    element: <EditBaseAddonCategory />
  }
];

const GENERAL_DASHBOARD_ROUTE: RouteObject[] = [
  {
    path: ROUTE_KEYS.CAREER_DETAILS,
    element: <CareerLayout />,
    children: JOB_DETAILS_ROUTES
  },
  {
    path: ROUTE_KEYS.BLOGS,
    element: <Blogs />
  },
  {
    path: ROUTE_KEYS.CREATE_POSITION,
    element: <CreateCareerPositionLayout />,
    children: CAREER_POSITION_FORM_ROUTES
  },

  {
    path: ROUTE_KEYS.CAREER,
    element: <CareersListingPage />
  },
  {
    path: ROUTE_KEYS.CREATE_BLOG,
    element: <CreateBlogLayout />,
    children: BLOG_FORM_ROUTES
  },
  {
    path: ROUTE_KEYS.FEEDS,
    element: <FeedsLayout />,
    children: FEED_ROUTES
  },
  {
    path: ROUTE_KEYS.SETTINGS,
    element: <SettingsLayout />,
    children: SETTINGS_ROUTES
  },

  {
    path: ROUTE_KEYS.STREAKS,
    element: <Streaks />
  },
  {
    path: ROUTE_KEYS.LEVELS,
    element: <Levels />
  },
  {
    path: ROUTE_KEYS.MAINTENANCE,
    element: <Maintenance />
  },
  {
    path: ROUTE_KEYS.GIFTCARD_CATEGORIES,
    element: <Categories />
  },
  {
    path: ROUTE_KEYS.GIFTCARD_CATEGORY_DETAILS,
    element: <GiftcardCategoryDetailsPage />
  },
  {
    path: ROUTE_KEYS.CREATE_GIFTCARD_CATEGORY,
    element: <CreateGiftCardCategory />
  },
  {
    path: ROUTE_KEYS.GIFTCARD_PLAIN_DESIGNS,
    element: <PlainDesigns />
  },
  {
    path: ROUTE_KEYS.TRASH,
    element: <Trash />,
    children: TRASH_ROUTES
  },
  {
    path: ROUTE_KEYS.CONVERSION_RATE,
    element: <ConversionRate />
  },
  {
    path: ROUTE_KEYS.STREAK_CONTROL,
    element: <StreakControl />
  },
  {
    path: ROUTE_KEYS.PAUSE_CONTROL,
    element: <PauseControl />
  },
  {
    path: ROUTE_KEYS.CASHBACK_CONTROL,
    element: <CashbackControl />
  },
  {
    path: ROUTE_KEYS.QR_CODE,
    element: <QrCode />
  },
  {
    path: ROUTE_KEYS.MANAGE_SECTIONS,
    element: <ManageSectionFormLayout />,
    children: MANAGE_SECTION_ROUTES
  }
];

export const ROOT_ROUTES: RouteObject[] = [
  {
    path: ROUTE_KEYS.LOGIN,
    element: (
      <UnauthRoute>
        <Login />
      </UnauthRoute>
    )
  },
  {
    path: ROUTE_PREFIX.FOOD,
    element: (
      <AuthRoute>
        <DashboardLayout />
      </AuthRoute>
    ),
    children: FOOD_DASHBOARD_ROUTES
  },
  {
    path: ROUTE_PREFIX.SHOP,
    element: (
      <AuthRoute>
        <DashboardLayout />
      </AuthRoute>
    ),
    children: SHOP_DASHBOARD_ROUTES
  },
  {
    element: (
      <AuthRoute>
        <DashboardLayout />
      </AuthRoute>
    ),
    children: GENERAL_DASHBOARD_ROUTE
  },

  {
    path: '*',
    element: (
      <UnauthRoute>
        <Login />
      </UnauthRoute>
    )
  }
];
export default createBrowserRouter(ROOT_ROUTES);
